import {cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    getReservationFailedTitle,
    RESERVATION_CLOSE_BUTTON_TEXT,
    RESERVATION_RATE_LIMIT_OVER_TEXT,
    RESERVATION_RATE_LIMITED_COPY,
    RESERVATION_RETRY_BUTTON_TEXT
} from "../constants/reservation_copy";
import {IReservationError} from "../types/IReservationError";
import {reservationStepCenteredContentStyle, reservationStepTextStyle} from "./reservation_step_styles";
import {renderCountdown, renderWithHotlineLink} from "./reservation_text";

interface IProps {
    titleId: string;
    descriptionId: string;
    error: IReservationError;
    // countdown before a rate-limited failure can be retried, 0 when the retry is available right away
    retrySecondsLeft: number;
    onRetry: () => void;
    onClose: () => void;
    className?: string;
}

// A failure that ends the code step - retried from here, or closed when it cannot be retried
export const ReservationFailedNotice = (props: IProps) => {
    const {titleId, descriptionId, error, retrySecondsLeft, onRetry, onClose, className} = props;

    const isRateLimited = error.kind === "rate_limited";
    const isCountingDown = isRateLimited && retrySecondsLeft > 0;

    return (
        <div className={cx(reservationStepCenteredContentStyle, className)} data-testid={RP_RESERVATION_TEST_IDS.ERROR_NOTICE}>
            <div aria-hidden="true">
                <InfoIcon size="2.8" wrapperSize="5.6" wrapperColor="var(--colors-beige-subtle)" />
            </div>

            <div className={reservationStepTextStyle}>
                {/* the countdown stays outside the alert - an atomic live region would be read out again on every tick */}
                <div role="alert" className={reservationStepTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                        {getReservationFailedTitle(error)}
                    </Text>

                    {isCountingDown ? null : (
                        <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                            {/* "wait a moment" is stale once the wait is over */}
                            {isRateLimited ? RESERVATION_RATE_LIMIT_OVER_TEXT : renderWithHotlineLink(error.message)}
                        </Text>
                    )}
                </div>

                {isCountingDown ? (
                    <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                        <span role="timer">{renderCountdown(RESERVATION_RATE_LIMITED_COPY, retrySecondsLeft)}</span>
                    </Text>
                ) : null}
            </div>

            {error.retryable ? (
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    disabled={isCountingDown}
                    onClick={onRetry}
                    dataTestId={RP_RESERVATION_TEST_IDS.RETRY_BUTTON}
                >
                    {RESERVATION_RETRY_BUTTON_TEXT}
                </Button>
            ) : (
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    onClick={onClose}
                    dataTestId={RP_RESERVATION_TEST_IDS.ERROR_CLOSE_BUTTON}
                >
                    {RESERVATION_CLOSE_BUTTON_TEXT}
                </Button>
            )}
        </div>
    );
};
import {cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {
    getReservationFailedTitle,
    RESERVATION_CLOSE_BUTTON_TEXT,
    RESERVATION_RATE_LIMIT_OVER_TEXT,
    RESERVATION_RATE_LIMITED_COPY,
    RESERVATION_RETRY_BUTTON_TEXT
} from "../constants/reservation_copy";
import {IReservationError} from "../types/IReservationError";
import {reservationStepCenteredContentStyle, reservationStepTextStyle} from "./reservation_step_styles";
import {renderCountdown, renderWithHotlineLink} from "./reservation_text";

interface IProps {
    titleId: string;
    descriptionId: string;
    error: IReservationError;
    // countdown before a rate-limited failure can be retried, 0 when the retry is available right away
    retrySecondsLeft: number;
    onRetry: () => void;
    onClose: () => void;
    className?: string;
}

// A failure that ends the code step - retried from here, or closed when it cannot be retried
export const ReservationFailedNotice = (props: IProps) => {
    const {titleId, descriptionId, error, retrySecondsLeft, onRetry, onClose, className} = props;

    const isRateLimited = error.kind === "rate_limited";
    const isCountingDown = isRateLimited && retrySecondsLeft > 0;

    return (
        <div className={cx(reservationStepCenteredContentStyle, className)} data-testid={RP_RESERVATION_TEST_IDS.ERROR_NOTICE}>
            <div aria-hidden="true">
                <InfoIcon size="2.8" wrapperSize="5.6" wrapperColor="var(--colors-beige-subtle)" />
            </div>

            <div className={reservationStepTextStyle}>
                {/* the countdown stays outside the alert - an atomic live region would be read out again on every tick */}
                <div role="alert" className={reservationStepTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" align="center" color="var(--colors-secondary)">
                        {getReservationFailedTitle(error)}
                    </Text>

                    {isCountingDown ? null : (
                        <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                            {/* "wait a moment" is stale once the wait is over */}
                            {isRateLimited ? RESERVATION_RATE_LIMIT_OVER_TEXT : renderWithHotlineLink(error.message)}
                        </Text>
                    )}
                </div>

                {isCountingDown ? (
                    <Text as="p" id={descriptionId} variant="body_copy_2" align="center" color="var(--colors-gray-800)">
                        <span role="timer">{renderCountdown(RESERVATION_RATE_LIMITED_COPY, retrySecondsLeft)}</span>
                    </Text>
                ) : null}
            </div>

            {error.retryable ? (
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    disabled={isCountingDown}
                    onClick={onRetry}
                    dataTestId={RP_RESERVATION_TEST_IDS.RETRY_BUTTON}
                >
                    {RESERVATION_RETRY_BUTTON_TEXT}
                </Button>
            ) : (
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    onClick={onClose}
                    dataTestId={RP_RESERVATION_TEST_IDS.ERROR_CLOSE_BUTTON}
                >
                    {RESERVATION_CLOSE_BUTTON_TEXT}
                </Button>
            )}
        </div>
    );
};
